import { ReportHandler } from 'web-vitals';

export const webVitalsLoader = {
  load: () => import('web-vitals'),
};

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  if (typeof onPerfEntry === 'function') {
    webVitalsLoader
      .load()
      .then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
        getCLS(onPerfEntry);
        getFID(onPerfEntry);
        getFCP(onPerfEntry);
        getLCP(onPerfEntry);
        getTTFB(onPerfEntry);
      });
  }
};

export default reportWebVitals;
